<div class="zoom-control">
  <div class="zoom-control__buttons">
    <button class="b-button zoom-control__zoom-out" (click)="zoomOut()" [ngClass]="{disabled: isDisabled}">
      <img
        class="image zoom-icon__image"
        ngSrc="/assets/images/dashboard/papaya/papayaviewer_zoom-out.svg"
        height="16"
        width="16"
        alt="zoom-out"
      >
    </button>

    <div class="zoom-control__zoom-value">
      x{{ zoomControl.value | number: '1.1' }}
    </div>

    <button class="b-button zoom-control__zoom-in" (click)="zoomIn()" [ngClass]="{disabled: isDisabled}">
      <img
        class="image zoom-icon__image"
        ngSrc="/assets/images/dashboard/papaya/papayaviewer_zoom-in.svg"
        height="16"
        width="16"
        alt="zoom-in"
      >
    </button>
  </div>


  <div class="zoom-control__slider mat-slider mat-slider_hidden-label">
    <mat-slider
      class="zoom-control__mat-slider"
      [min]="minimalZoomAvailable"
      [max]="maximalZoomAvailable"
      [step]="zoomStep"
      #slider
    >
      <input matSliderThumb [formControl]="zoomControl">
    </mat-slider>
  </div>
</div>
